import { FC, Suspense } from 'react';

import classnames from 'classnames';
import dibsCss from 'dibs-css';

import { LocalizedListingUnavailableIcon } from 'dibs-elements/exports/LocalizedListingUnavailableIcon';

const VECTOR_TEXT_HEIGHT = 14;

export const PdpSharedUnavailableListingBanner: FC<{ isMobile?: boolean }> = ({
    isMobile = false,
}) => {
    return (
        <Suspense
            fallback={
                <div
                    style={{ height: 42 }}
                    className={classnames({
                        [dibsCss.mbSmall]: !isMobile,
                        [dibsCss.mbMedium]: isMobile,
                        [dibsCss.mtSmall]: isMobile,
                    })}
                />
            }
        >
            <div
                className={classnames(
                    dibsCss.bgRed50,
                    dibsCss.plSmall,
                    dibsCss.prSmall,
                    dibsCss.ptXsmall,
                    dibsCss.pbXsmall,
                    dibsCss.roundedXxsmall,
                    {
                        [dibsCss.mbSmall]: !isMobile,
                        [dibsCss.mbMedium]: isMobile,
                        [dibsCss.mtSmall]: isMobile,
                    }
                )}
            >
                <div
                    className={classnames(dibsCss.mtXxsmall, dibsCss.mbXxsmall)}
                    style={{ height: VECTOR_TEXT_HEIGHT }}
                >
                    <LocalizedListingUnavailableIcon />
                </div>
            </div>
        </Suspense>
    );
};
